import { render, staticRenderFns } from "./TagsCreate.vue?vue&type=template&id=e5ab299e&scoped=true&"
import script from "./TagsCreate.vue?vue&type=script&lang=js&"
export * from "./TagsCreate.vue?vue&type=script&lang=js&"
import style0 from "./TagsCreate.vue?vue&type=style&index=0&id=e5ab299e&lang=scss&scoped=true&"
import style1 from "./TagsCreate.vue?vue&type=style&index=1&id=e5ab299e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5ab299e",
  null
  
)

export default component.exports